import { Redirect } from 'react-router-dom';
import {
  ProfileEmptyState,
  ProfilePageLayout
} from 'features/inventory-profiles/components/shared';
import { CONTACT_PROFILE_CONFIG } from 'features/inventory-profiles/constants';
import { useContactConversion } from 'hooks/useContactConversion';
import { UIStatus } from 'UI/constants/status';

import { ContactProfileV2 } from './ContactProfileV2';
import { getConvertedProfileRoute } from './ContactProfileV2.utils';

// While the conversion check runs, the page shows the same skeleton the profile shows while loading
const LOADING_HEADER = { entityType: CONTACT_PROFILE_CONFIG.type };

/**
 * Gate in front of ContactProfileV2: a converted contact is redirected to its Candidate or
 * Hiring Authority profile.
 * @param {Object} props
 * @param {number|string} props.id Contact (name) id
 * @param {boolean} [props.enableUrlNavigation] Forwarded to the container
 * @param {Function} [props.onEditionCompleted] Forwarded to the container
 * @param {string} [props.layoutClassName] Forwarded to the container
 */
export const ContactProfileV2Route = ({
  enableUrlNavigation,
  id,
  layoutClassName,
  onEditionCompleted
}) => {
  const conversion = useContactConversion({ nameId: id });
  const { entityConversionState } = conversion;

  if (conversion.shouldRenderProfileContent) {
    return (
      <ContactProfileV2
        id={id}
        enableUrlNavigation={enableUrlNavigation}
        onEditionCompleted={onEditionCompleted}
        layoutClassName={layoutClassName}
      />
    );
  }

  if (entityConversionState.results?.converted) {
    return <Redirect to={getConvertedProfileRoute(entityConversionState.results)} />;
  }

  if (conversion.status === UIStatus.Error) {
    return <ProfileEmptyState statusCode={entityConversionState.responseStatusCode} />;
  }

  return conversion.isLoading ? (
    <ProfilePageLayout
      header={LOADING_HEADER}
      isLoading
      enableUrlNavigation={enableUrlNavigation}
      layoutClassName={layoutClassName}
    />
  ) : null;
};
